"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upload = exports.pin = void 0;
const ofetch_1 = require("ofetch");
const utils_1 = require("./utils");
const PINEAPPLE_URL = 'https://pineapple.fyi';
const timeout = 10e3;
const defaultOptions = { retry: 2, retryDelay: 500, retryStatusCodes: [504] };
function pin(json, url = PINEAPPLE_URL) {
    const options = {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: {
            jsonrpc: '2.0',
            method: 'pin',
            params: json,
            id: null
        },
        timeout
    };
    return sendRequest(url, options);
}
exports.pin = pin;
function upload(body, url = `${PINEAPPLE_URL}/upload`) {
    const options = { method: 'POST', body, timeout };
    return sendRequest(url, options);
}
exports.upload = upload;
async function sendRequest(url, options) {
    try {
        return (await (0, ofetch_1.ofetch)(url, { ...defaultOptions, ...options })).result;
    }
    catch (e) {
        return Promise.reject({
            error: e.data?.error || {
                code: e.status || 0,
                message: e.statusText || utils_1.STATUS_CODE[e.status] || 'Network error'
            }
        });
    }
}
